module.exports = __webpack_public_path__ + "84191aa483486e83efda3cd09e468853.svg";